import { BaseComponent2 } from '../../_common/client/base-component2';
import { addMoveTrackingToStarAmountLink } from './add-move-tracking-to-star-amount-link';
import { convertStarNumberToWord } from '../helper/convert-star-number-to-word';
import { CrFilter } from '../types';
import { addListenersToDeselectButton } from './add-listeners-to-deselect-button';
import { trackStarAmountClickOnCrLandingPage } from './track-star-amount-click-on-cr-landing-page';
import { eventQBus } from '@otto-ec/global-resources/event-q-bus';

export const CR_FILTER_EVENT = 'ft5.customerReview.filter';

export type CrFilterEvent = {
    filter: CrFilter;
};

export class CustomerReviewStarFilterComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr-star-filter';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        const starAmountLinks = this.getChildElements('.pdp_cr_histogram__amount');
        starAmountLinks.forEach(linkElement => addMoveTrackingToStarAmountLink(linkElement));

        if (this.rootElement!.dataset.kind === 'CrLandingPage') {
            this.addListenersToStarRows();
            addListenersToDeselectButton(this.getDeselectButtonContainer());
        }
    }

    private addListenersToStarRows() {
        const starRows = this.getChildElements('.js_pdp_cr_histogram__container');
        if (starRows.length != 5) return;

        starRows.forEach(starRow => this.addListenersToStarRow(starRow));
    }

    private addListenersToStarRow(starRow: HTMLElement) {
        const starLink: HTMLElement | null = starRow.querySelector('[data-num-of-stars]');
        if (!starLink) return;

        starLink.addEventListener('click', () => {
            const eventData: CrFilterEvent = {
                filter: convertStarNumberToWord(starLink.dataset.numOfStars),
            };
            eventQBus.emit(CR_FILTER_EVENT, eventData);
            trackStarAmountClickOnCrLandingPage(starLink);
        });

        eventQBus.on(CR_FILTER_EVENT, eventData => {
            this.setRowSelectionStyleBasedOnFilter(starRow, eventData.filter);
        });
    }

    private setRowSelectionStyleBasedOnFilter(starRow: HTMLElement, filter: CrFilter) {
        const starLink: HTMLElement | null = starRow.querySelector('[data-num-of-stars]');
        if (!starLink) return;

        if (filter === convertStarNumberToWord(starLink.dataset.numOfStars)) {
            /*                                                            */
            if (starRow.classList.contains('pdp_cr_histogram__row--selected')) return;
            starRow.classList.add('pdp_cr_histogram__row--selected');
            return;
        }
        starRow.classList.remove('pdp_cr_histogram__row--selected');
    }

    private getDeselectButtonContainer() {
        return this.getRootElement().querySelector<HTMLElement>('.js_pdp_cr-star-filter__deselect-button-container');
    }
}
